import React, { SyntheticEvent } from "react";
import { connect } from "react-redux";
import { IAppState, IOffline } from "../../state/interfaces";
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { IESignatureForm, IEsignatureModuleOption, ESIG_MODULE_OPTION_TYPES } from "../../classes/ExternalQuote";
import { FULL_QUOTE_STEPS, QUOTE_QUESTIONS, COMPONENTS } from "../../AppConstants";
import { QuoteStep } from "./QuoteStepLayout";
import { ValidatableForm } from "../../components/ValidatableForm"
import { Form } from 'react-bootstrap'
import Utilities from "../../classes/Utilities";
import { IPerson, IQuoteApiClient, ILOBApiClient, IPaths } from "../../classes/Domain";
import { Checkbox } from 'react-input-checkbox';
import 'react-input-checkbox/lib/react-input-checkbox.min.css';
import { validationUtils, IValidationFailure } from "../../validation/Validation";
import { Rifm } from "rifm";
import ValidatableFormGroup from "../../components/ValidatableFormGroup";
import Question from "../../components/Question";
import QuoteActions from "../../state/appActions";
import FullQuoteActions from "../../state/fullQuoteActions";


interface IProps extends IQuoteStepComponentProps {
    offlineData: IOffline | null;
    insured: IPerson,
    eSignatureFormsCount: number,
    currentForm: IESignatureForm,
    currentFormIndex: number,
    forms: Array<IESignatureForm>,
    rtrQuoteId: number,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

interface IState extends IQuoteStepState {
    insuredName: string,
    options: Array<IEsignatureModuleOption>
    formProcessed: boolean,
    forms: Array<IESignatureForm>,
    errors: any;
}

interface IUpdateAgreement {
    rtrQuoteId: number,
    esignatureCode: string,
    insuredName: string,
    needToSign: boolean,
    lastForm: boolean,
    options: Array<IUpdateAgreementOption>
}

interface IUpdateAgreementOption {
    value: string,
    type: number
}

class ESignatureForm extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        
        this.state = {
            insuredName: this.props.currentForm.module.applicantSignature,
            options: this.props.currentForm.module.moduleOptions,
            formProcessed: !this.props.currentForm.module.needToSign,
            forms: this.props.forms,
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.FINALIZE,
            validationData => {
                this.setState({ updatingStore: !this.props.currentForm.module.needToSign, errors: validationData }, () => console.log(validationUtils.hasValidationErrorFor(this.state.errors, "insuredName")) );
            });

        //this.state.forms[this.props.currentFormIndex].module.moduleOptions?.map((option, i) => {
        //    this.setOptionValue(this.props.currentFormIndex, i, option.value);
        //});

        this.setState({ ...this.state, options: this.props.currentForm.module.moduleOptions });
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            nextProps.meta.propsSource = "";

            return {
                ...prevState,
                formProcessed: !nextProps.currentForm.module.needToSign
            };
        }

        return prevState;
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(FULL_QUOTE_STEPS.FINALIZE);
    }

    setOptionValue(formIndex: number, optionIndex: number, value: string) {
        const { forms } = { ...this.state };

        forms[formIndex].module.moduleOptions[optionIndex].value = value;
        this.setState({ ...this.state, options: forms[formIndex].module.moduleOptions, forms });
    }

    goNextPage(lastForm: boolean) {
        const nextUrl = lastForm
            ? this.props.offlineData && this.props.offlineData.isActive
                ? this.props.PATHS.FQ_OFFLINE
                : this.props.PATHS.FQ_PAYMENT
            : Utilities.formatUrl(this.props.PATHS.FQ_ESIGNATURE, (this.props.currentFormIndex + 1).toString());

        let _formProcessed = !lastForm
            ? this.state.forms[this.props.currentFormIndex + 1].module.needToSign
            : false

        let _this = this;
        setTimeout(function () {
            _this.setState({ ..._this.state, formProcessed: !_formProcessed, updatingStore: false, errors: null, options: [] });
            _this.props.history.push(nextUrl);
        }, 1000)
    }

    stopUpdate() {
        this.setState({ ...this.state, updatingStore: false });
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.setState({ updatingStore: true }, () => {
            const lastForm = this.props.currentFormIndex === this.props.eSignatureFormsCount - 1;

            this.props.updateAppState({
                rtrQuoteId: this.props.rtrQuoteId,
                esignatureCode: this.props.currentForm.code,
                insuredName: this.props.currentForm.module.applicantSignature,
                needToSign: this.props.currentForm.module.needToSign,
                lastForm: lastForm,
                options: this.state.forms[this.props.currentFormIndex].module.moduleOptions
            })
            .then(() => {
                this.goNextPage(lastForm);
            },
            () => {
                this.stopUpdate();
            });
        });
    }

    handleAgreeChange(event: SyntheticEvent) {
        this.setState({ ...this.state, formProcessed: !this.state.formProcessed});
    }

    render() {
        return (
            <QuoteStep id="esignature" className="e-signature">
                <ValidatableForm hasErrors={null != this.state.errors} onSubmit={this.next}>
                    <div className="titleArea">
                        <h5>{this.props.currentForm.name}</h5>
                    </div>

                    <div className="e-signature-form-wrap">
                        <p dangerouslySetInnerHTML={{ __html: this.props.currentForm.module.wording }}></p>
                    </div>

                    {
                        this.state.forms[this.props.currentFormIndex].module.moduleOptions?.map((option, i) => {
                            switch (option.type) {
                                case ESIG_MODULE_OPTION_TYPES.YES_NO: {
                                    return <Question
                                        name={option.label}
                                        key={Utilities.uniqueId()}
                                        selected={(v) => { this.setOptionValue(this.props.currentFormIndex, i, v); }}
                                        error={ validationUtils.getValidationErrorFor(this.state.errors, option.label) }
                                        selectedValue={option.value}
                                        items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                                        lable={option.label} />
                                }
                                case ESIG_MODULE_OPTION_TYPES.YES_NO_SELECTED: {
                                    //return <Question
                                    //    name={option.label}
                                    //    key={Utilities.uniqueId()}
                                    //    disabled={true}
                                    //    error={validationUtils.getValidationErrorFor(this.state.errors, option.label)}
                                    //    selectedValue={option.value}
                                    //    items={[QUOTE_QUESTIONS.YES_NO.YES, QUOTE_QUESTIONS.YES_NO.NO]}
                                    //    lable={option.label} />

                                    return <div>
                                        <Form.Check type="checkbox" key={Utilities.uniqueId()}>
                                            <Form.Check.Input
                                                type="checkbox"
                                                checked={option.value === QUOTE_QUESTIONS.YES_NO.YES}
                                                disabled={true}
                                                isValid />
                                            <Form.Check.Label className="lable-grey">{option.label}</Form.Check.Label>
                                        </Form.Check>
                                    </div>
                                }
                                case ESIG_MODULE_OPTION_TYPES.PHONE_NUMBER: {
                                    return <Rifm
                                        accept={/\d/g}
                                        mask={10 <= option.value.length}
                                        format={Utilities.formatPhone}
                                        value={option.value}
                                        key={option.label}
                                        onChange={(v) => { this.setOptionValue(this.props.currentFormIndex, i, v); }}>
                                        {({ value, onChange }) => (
                                            <ValidatableFormGroup
                                                label={option.label}
                                                placeholder="(___)___-____"
                                                value={value}
                                                validated={null !== this.state.errors}
                                                validationError={ validationUtils.getValidationErrorFor(this.state.errors, option.label) }
                                                onChange={(e) => { onChange(e) }} />
                                        )}
                                    </Rifm>
                                }
                                default: {
                                    break;
                                }
                            } 
                        })
                    }

                    {this.props.currentForm.module.needToSign ?
                        <Form.Check type="checkbox">
                            <p className="infoBold">Applicant's eSignature: [{this.props.currentForm.module.applicantSignature}]</p>
                            <p className="infoBold">* Please check box to confirm</p>
                            <Checkbox theme="bootstrap-checkbox_esign"
                                children={<span />}
                                value={this.state.formProcessed}
                                onChange={(e) => { this.handleAgreeChange(e) }}></Checkbox>
                            <Form.Check.Label className="esig-start">{this.props.currentForm.module.esigStart}</Form.Check.Label>

                            <Form.Control
                                onChange={(e) => { this.setStateValue(e.target.value, "insuredName") }}
                                value={this.props.currentForm.module.applicantSignature}
                                maxLength={200}
                                className={"insured-name"} />
                            {validationUtils.hasValidationErrorFor(this.state.errors, "insuredName")
                                ? <Form.Control.Feedback type="invalid">
                                    {validationUtils.getValidationErrorFor(this.state.errors, "insuredName")}
                                </Form.Control.Feedback>
                                : null
                            }

                            <p className="esig-end">
                                {this.props.currentForm.module.esigEnd}
                            </p>
                        </Form.Check> : ""}

                    <div className="btnContainer">
                        <ButtonContinue
                            label="Continue"
                            className="btn-sign"
                            disabled={this.state.updatingStore || !this.state.formProcessed || this.state.options.some(x => x.isValid == false)}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                        </div>
                </ValidatableForm>

            </QuoteStep>
        );
    }

}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {

    const currentFormIndex = !ownProps.match.params["formIndex"]
        ? 0
        : parseInt(ownProps.match.params["formIndex"], 10);
    const currentForm = state.externalQuote?.esignatureForms[currentFormIndex];

    return {
        offlineData: state.appOfflineData,
        insured: state.externalQuote?.insured,
        eSignatureFormsCount: state.externalQuote?.esignatureForms.length,
        currentForm,
        currentFormIndex,
        forms: state.externalQuote?.esignatureForms,
        rtrQuoteId: state.externalQuote?.rtrQuoteId,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.FINALIZE)),
        updateAppState: (update: IUpdateAgreement) => dispatch(fullQuoteActions.updateESignatureAgreement(update.rtrQuoteId, update.esignatureCode,
            update.insuredName, update.needToSign, update.lastForm, update.options))
    };
};

export default connect(mapProps, mapDispatch)(ESignatureForm);